import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import consts from '../../constant';

const getHeaders = () => ({
    headers: {
        Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
    },
});

// Crypto Thunks
export const fetchDepositOptions = createAsyncThunk(
    'deposit/fetchDepositOptions',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${consts.BackendUrl}/deposit/options`, getHeaders());
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const addCurrency = createAsyncThunk(
    'deposit/addCurrency',
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${consts.BackendUrl}/deposit/admin/currency`, data, getHeaders());
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const updateCurrency = createAsyncThunk(
    'deposit/updateCurrency',
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const response = await axios.put(`${consts.BackendUrl}/deposit/admin/currency/${id}`, data, getHeaders());
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const deleteCurrency = createAsyncThunk(
    'deposit/deleteCurrency',
    async (id, { rejectWithValue }) => {
        try {
            const response = await axios.delete(`${consts.BackendUrl}/deposit/admin/currency/${id}`, getHeaders());
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

// Network Thunks
export const addNetwork = createAsyncThunk(
    'deposit/addNetwork',
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${consts.BackendUrl}/deposit/admin/network`, data, getHeaders());
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const updateNetwork = createAsyncThunk(
    'deposit/updateNetwork',
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const response = await axios.put(`${consts.BackendUrl}/deposit/admin/network/${id}`, data, getHeaders());
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const deleteNetwork = createAsyncThunk(
    'deposit/deleteNetwork',
    async (id, { rejectWithValue }) => {
        try {
            const response = await axios.delete(`${consts.BackendUrl}/deposit/admin/network/${id}`, getHeaders());
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

// Fiat Thunks
export const addFiatMethod = createAsyncThunk(
    'deposit/addFiatMethod',
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${consts.BackendUrl}/deposit/admin/fiat-method`, data, getHeaders());
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const updateFiatMethod = createAsyncThunk(
    'deposit/updateFiatMethod',
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const response = await axios.put(`${consts.BackendUrl}/deposit/admin/fiat-method/${id}`, data, getHeaders());
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const deleteFiatMethod = createAsyncThunk(
    'deposit/deleteFiatMethod',
    async (id, { rejectWithValue }) => {
        try {
            const response = await axios.delete(`${consts.BackendUrl}/deposit/admin/fiat-method/${id}`, getHeaders());
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

// History Thunks
export const fetchDepositHistory = createAsyncThunk(
    'deposit/fetchDepositHistory',
    async (params, { rejectWithValue }) => {
        try {
            // Convert params to query string for GET request
            const queryParams = new URLSearchParams(params).toString();
            const response = await axios.get(`${consts.BackendUrl}/deposit/all-deposits?${queryParams}`, getHeaders());
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const verifyDeposit = createAsyncThunk(
    'deposit/verifyDeposit',
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const response = await axios.put(`${consts.BackendUrl}/deposit/admin/deposit/${id}`, data, getHeaders());
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

const depositSlice = createSlice({
    name: 'deposit',
    initialState: {
        currencies: [],
        networks: [],
        fiatMethods: [],
        depositHistory: [],
        historyTotal: 0,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Fetch Options
            .addCase(fetchDepositOptions.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchDepositOptions.fulfilled, (state, action) => {
                state.loading = false;
                state.currencies = action.payload.currencies || [];
                state.networks = action.payload.networks || [];
                state.fiatMethods = action.payload.fiatMethods || [];
            })
            .addCase(fetchDepositOptions.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Fetch History
            .addCase(fetchDepositHistory.fulfilled, (state, action) => {
                state.depositHistory = action.payload.result.docs?.map((item) => {
                    return {
                        ...item,
                        proof_tx_hash: item.type === 'fiat' ? item.proof : item.tx_hash,
                    };
                }) || [];
                state.historyTotal = action.payload.result.totalDocs || 0;
            });
    },
});

export default depositSlice.reducer;
